import { useEffect, useMemo, useState } from "react";
import { Card } from "../../../components/Card";
import {
    Box,
    Checkbox,
    CircularProgress,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
} from "@mui/material";
import { StyledTab, StyledTabs } from "../bbs/BBS";
import OverviewFilters from "./overview/OverviewFilters";
import StoreView from "./store/StoreView";
import CollaborationsView from "./collaborations/CollaborationsView";
import PaymentsView from "./payments/PaymentsView";
import TargetView from "./target/TargetView";
import LastRefreshed from "../LastRefreshed";
import useSWR from "swr";
import API_ENDPOINTS from "../../../apis/endpoints";

const tabs = [
    { id: "0", title: "Overview" },
    { id: "1", title: "Stores" },
    { id: "2", title: "Collaborations" },
    { id: "3", title: "Payments" },
    { id: "4", title: "Targets" },
];

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 10.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const CreatorsTech = () => {
    const [value, setValue] = useState(0);
    const [filterBy, setFilterBy] = useState("weeklyView");
    const [selectedMetric, setSelectedMetric] = useState("financial");
    const [selectedWeeks, setSelectedWeeks] = useState([]);

    const { data: weekDataSet, isLoading: isWeeksLoading } = useSWR(
        API_ENDPOINTS.CREATORS_TECH_WEEKS
    );
    const { data: weeks = [], refreshed_at } = weekDataSet ?? {};

    const { data: CreatorTechData, isLoading: isDataLoading } = useSWR(
        selectedWeeks?.length > 0
            ? `${API_ENDPOINTS.CREATORS_TECH_DATA}?weeks=${selectedWeeks.join(",")}`
            : null
    );

    useEffect(() => {
        if (weeks?.length > 0 && selectedWeeks?.length === 0) {
            setSelectedWeeks(weeks.slice(-6).map((w) => w.key));
        }
    }, [weeks, selectedWeeks]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleWeekChange = (event) => {
        setSelectedWeeks(event?.target?.value || []);
    };

    const filteredData = useMemo(() => {
        if (!CreatorTechData) return [];
        return CreatorTechData;
    }, [CreatorTechData, filterBy]);

    return (
        <Card>
            <div
                className="header-section"
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Box>
                    <StyledTabs
                        value={value}
                        onChange={handleChange}
                        aria-label="Creator Tech tabs"
                    >
                        {tabs.map((tab, index) => (
                            <StyledTab
                                key={tab?.id}
                                label={tab?.title}
                                {...a11yProps(index)}
                            />
                        ))}
                    </StyledTabs>
                </Box>

                {/* Week Selector */}
                <FormControl sx={{ m: 1, width: 300 }}>
                    <InputLabel id="week-multi-select-label">Weeks</InputLabel>
                    <Select
                        labelId="week-multi-select-label"
                        id="week-multi-select"
                        multiple
                        value={selectedWeeks}
                        onChange={handleWeekChange}
                        input={<OutlinedInput label="All Weeks" />}
                        renderValue={(selected) =>
                            weeks?.length === selected?.length
                                ? "All weeks"
                                : weeks
                                      ?.filter((week) =>
                                          selected.includes(week.key)
                                      )
                                      .map((week) => week.name)
                                      .join(", ")
                        }
                        MenuProps={MenuProps}
                    >
                        {weeks?.map((week) => (
                            <MenuItem key={week?.key} value={week?.key}>
                                <Checkbox
                                    checked={selectedWeeks?.includes(week?.key)}
                                />
                                <ListItemText primary={week?.name} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            {isDataLoading ? (
                <div style={{ padding: 40, textAlign: "center" }}>
                    <CircularProgress />
                </div>
            ) : (
                <>
                    {value === 0 && (
                        <OverviewFilters
                            filteredData={filteredData}
                            filterBy={filterBy}
                            setFilterBy={setFilterBy}
                            selectedMetric={selectedMetric}
                            setSelectedMetric={setSelectedMetric}
                        />
                    )}
                    {value === 1 && (
                        <StoreView
                            filteredData={filteredData}
                            filterBy={filterBy}
                        />
                    )}
                    {value === 2 && (
                        <CollaborationsView
                            filteredData={filteredData}
                            filterBy={filterBy}
                        />
                    )}
                    {value === 3 && (
                        <PaymentsView
                            filteredData={filteredData}
                            filterBy={filterBy}
                        />
                    )}
                    {value === 4 && (
                        <TargetView
                            filteredData={filteredData}
                            filterBy={filterBy}
                        />
                    )}
                </>
            )}

            <LastRefreshed date={refreshed_at} />
        </Card>
    );
};

export default CreatorsTech;
